import { render, staticRenderFns } from "./KycDetailsField.vue?vue&type=template&id=071805aa&scoped=true&"
import script from "./KycDetailsField.vue?vue&type=script&lang=js&"
export * from "./KycDetailsField.vue?vue&type=script&lang=js&"
import style0 from "./KycDetailsField.vue?vue&type=style&index=0&id=071805aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071805aa",
  null
  
)

export default component.exports